// extracted by mini-css-extract-plugin
export default {"container":"tooltip_container__p-mKX"};